import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddButtonComponent = ({ templateCategory, onChange }) => {
    const [callPhoneRows, setCallPhoneRows] = useState([]);
    const [copyOfferRows, setCopyOfferRows] = useState([]);
    const [visitWebsiteRows, setVisitWebsiteRows] = useState([]);
    const [customQuickReplyRows, setCustomQuickReplyRows] = useState([]);
    const [marketingOptOutRows, setMarketingOptOutRows] = useState([]);
    const [dropOpen, setDropOpen] = useState(false);
    const [dropPos, setDropPos] = useState({ top: 0, left: 0 });
    const dropRef = useRef(null);

    const menuRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            const clickedTrigger = dropRef.current && dropRef.current.contains(e.target);
            const clickedMenu = menuRef.current && menuRef.current.contains(e.target);
            if (!clickedTrigger && !clickedMenu) setDropOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const openDrop = () => {
        if (dropRef.current) {
            const rect = dropRef.current.getBoundingClientRect();
            setDropPos({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        }
        setDropOpen(v => !v);
    };

    const handleAddMarketingOptOutRow = () => {
        if (marketingOptOutRows.length >= 1) {
            toast.error('You can only add one Marketing opt-out button.', { autoClose: 3000 });
            return;
        }
        setMarketingOptOutRows([...marketingOptOutRows, { id: Date.now(), consentChecked: true }]);
    };

    const handleRemoveMarketingOptOutRow = (id) => {
        setMarketingOptOutRows(marketingOptOutRows.filter((row) => row.id !== id));
    };

    const handleConsentChange = (id, checked) => {
        setMarketingOptOutRows(marketingOptOutRows.map((row) => row.id === id ? { ...row, consentChecked: checked } : row));
    };

    const handleAddCustomQuickReplyRow = () => {
        if (customQuickReplyRows.length >= 10) {
            toast.error('You can only add up to 10 quick reply buttons.', { autoClose: 3000 });
            return;
        }
        setCustomQuickReplyRows([...customQuickReplyRows, { id: Date.now(), buttonText: '' }]);
    };

    const handleRemoveCustomQuickReplyRow = (id) => {
        setCustomQuickReplyRows(customQuickReplyRows.filter((row) => row.id !== id));
    };

    const handleCustomQuickReplyChange = (id, value) => {
        setCustomQuickReplyRows(customQuickReplyRows.map((row) => row.id === id ? { ...row, buttonText: value } : row));
    };

    const handleAddVisitWebsiteRow = () => {
        if (visitWebsiteRows.length >= 2) {
            toast.error('You can only add up to 2 Visit Website buttons.', { autoClose: 3000 });
            return;
        }
        setVisitWebsiteRows([...visitWebsiteRows, { id: Date.now(), buttonText: '', dropdownValue: 'Static', url: '' }]);
    };

    const handleRemoveVisitWebsiteRow = (id) => {
        setVisitWebsiteRows(visitWebsiteRows.filter((row) => row.id !== id));
    };

    const handleVisitWebsiteChange = (id, field, value) => {
        setVisitWebsiteRows(visitWebsiteRows.map((row) => row.id === id ? { ...row, [field]: value } : row));
    };

    const handleAddCallPhoneRow = () => {
        if (callPhoneRows.length >= 1) {
            toast.error('You can only add one Call Phone Number button.', { autoClose: 3000 });
            return;
        }
        setCallPhoneRows([...callPhoneRows, { id: Date.now(), buttonText: '', mobileNumber: '' }]);
    };

    const handleRemoveCallPhoneRow = (id) => {
        setCallPhoneRows(callPhoneRows.filter((row) => row.id !== id));
    };

    const handleMobileNumberChange = (id, value, field) => {
        setCallPhoneRows(callPhoneRows.map((row) => row.id === id ? { ...row, [field]: value } : row));
    };

    const handleAddCopyOfferRow = () => {
        if (copyOfferRows.length >= 1) {
            toast.error('You can only add one Copy Offer Code button.', { autoClose: 3000 });
            return;
        }
        setCopyOfferRows([...copyOfferRows, { id: Date.now(), offerCode: '' }]);
    };

    const handleRemoveCopyOfferRow = (id) => {
        setCopyOfferRows(copyOfferRows.filter((row) => row.id !== id));
    };

    const handleOfferCodeChange = (id, value) => {
        setCopyOfferRows(copyOfferRows.map((row) => row.id === id ? { ...row, offerCode: value } : row));
    };

    const isValidIndianMobileNumber = (number) => /^[6-9]\d{9}$/.test(number);
    const isValidOfferCode = (code) => /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{3,15}$/.test(code);
    const isValidDomain = (url, type) => {
        if (type === 'Static') return /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,4}(\/.*)?$/.test(url);
        if (type === 'Dynamic') return /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,4}(\/.*)?\/\{\{1\}\}$/.test(url);
        return false;
    };

    const generateJsonObject = () => {
        const jsonObject1 = [
            ...marketingOptOutRows.map(() => ({ type: 'opt_out' })),
            ...customQuickReplyRows.map((row) => ({ type: 'quick_reply', content: row.buttonText })),
            ...visitWebsiteRows.map((row) => ({ type: 'visit_website', button: row.buttonText, site_url: row.url })),
            ...callPhoneRows.map((row) => ({ type: 'call_phone', button: row.buttonText, site_url: row.mobileNumber })),
            ...copyOfferRows.map((row) => ({ type: 'copy_offer', site_url: row.offerCode })),
        ];
        onChange(jsonObject1);
    };

    useEffect(() => {
        generateJsonObject();
    }, [callPhoneRows, copyOfferRows, visitWebsiteRows, customQuickReplyRows, marketingOptOutRows]);

    return (
        <div style={s.wrap}>
            {/* Add Button trigger */}
            <div ref={dropRef} style={{ display: 'inline-block' }}>
                <button style={s.addBtn} type="button" onClick={openDrop}>
                    <i className="bi bi-plus-lg" style={{ marginRight: 6 }}></i>
                    Add Button
                    <i className={`bi bi-chevron-${dropOpen ? 'up' : 'down'}`} style={{ marginLeft: 6, fontSize: 11 }}></i>
                </button>
            </div>

            {/* Fixed-position dropdown */}
            {dropOpen && (
                <div ref={menuRef} style={{ ...s.dropMenu, position: 'fixed', top: dropPos.top, left: dropPos.left, zIndex: 9999 }}>
                    <div style={s.dropSection}>Quick Reply Button</div>
                    {templateCategory === 'Marketing' && (
                        <div style={s.dropItem} onClick={() => { handleAddMarketingOptOutRow(); setDropOpen(false); }}>
                            <i className="bi bi-megaphone" style={{ marginRight: 8, color: '#1565c0' }}></i>
                            Marketing opt-out
                        </div>
                    )}
                    <div style={s.dropItem} onClick={() => { handleAddCustomQuickReplyRow(); setDropOpen(false); }}>
                        <i className="bi bi-reply" style={{ marginRight: 8, color: '#1565c0' }}></i>
                        Custom
                    </div>
                    <div style={s.dropDivider}></div>
                    <div style={s.dropSection}>Call to Action Button</div>
                    <div style={s.dropItem} onClick={() => { handleAddVisitWebsiteRow(); setDropOpen(false); }}>
                        <i className="bi bi-globe" style={{ marginRight: 8, color: '#1565c0' }}></i>
                        Visit Website <span style={s.dropHint}>(Max 2)</span>
                    </div>
                    <div style={s.dropItem} onClick={() => { handleAddCallPhoneRow(); setDropOpen(false); }}>
                        <i className="bi bi-telephone" style={{ marginRight: 8, color: '#1565c0' }}></i>
                        Call Phone Number <span style={s.dropHint}>(Max 1)</span>
                    </div>
                    <div style={s.dropItem} onClick={() => { handleAddCopyOfferRow(); setDropOpen(false); }}>
                        <i className="bi bi-ticket-perforated" style={{ marginRight: 8, color: '#1565c0' }}></i>
                        Copy Offer Code <span style={s.dropHint}>(Max 1)</span>
                    </div>
                </div>
            )}

            {/* Call Phone rows */}
            {callPhoneRows.map((row) => (
                <div key={row.id} style={s.row}>
                    <span style={s.rowLabel}><i className="bi bi-telephone" style={{ marginRight: 5 }}></i>Call Phone</span>
                    <input type="text" style={s.input} placeholder="Button Text" value={row.buttonText || ''} onChange={(e) => handleMobileNumberChange(row.id, e.target.value, 'buttonText')} />
                    <div style={{ flex: 2 }}>
                        <input
                            type="text"
                            style={{ ...s.input, ...(row.mobileNumber && !isValidIndianMobileNumber(row.mobileNumber) ? s.inputError : {}) }}
                            placeholder="10-digit mobile number"
                            value={row.mobileNumber}
                            onChange={(e) => handleMobileNumberChange(row.id, e.target.value, 'mobileNumber')}
                        />
                        {row.mobileNumber && !isValidIndianMobileNumber(row.mobileNumber) && (
                            <span style={s.errorText}>Please enter a valid 10-digit Indian mobile number.</span>
                        )}
                    </div>
                    <button style={s.removeBtn} onClick={() => handleRemoveCallPhoneRow(row.id)} title="Remove"><i className="bi bi-trash"></i></button>
                </div>
            ))}

            {/* Copy Offer rows */}
            {copyOfferRows.map((row) => (
                <div key={row.id} style={s.row}>
                    <span style={s.rowLabel}><i className="bi bi-ticket-perforated" style={{ marginRight: 5 }}></i>Copy Offer</span>
                    <input type="text" style={{ ...s.input, background: '#f3f4f6', color: '#6b7280' }} value="Copy Code" disabled />
                    <div style={{ flex: 2 }}>
                        <input
                            type="text"
                            style={{ ...s.input, ...(row.offerCode && !isValidOfferCode(row.offerCode) ? s.inputError : {}) }}
                            placeholder="Enter Offer Code"
                            maxLength="15"
                            value={row.offerCode}
                            onChange={(e) => handleOfferCodeChange(row.id, e.target.value)}
                        />
                        {row.offerCode && !isValidOfferCode(row.offerCode) && (
                            <span style={s.errorText}>3-15 chars, at least 1 letter and 1 number, no spaces.</span>
                        )}
                    </div>
                    <button style={s.removeBtn} onClick={() => handleRemoveCopyOfferRow(row.id)} title="Remove"><i className="bi bi-trash"></i></button>
                </div>
            ))}

            {/* Visit Website rows */}
            {visitWebsiteRows.map((row) => (
                <div key={row.id} style={s.row}>
                    <span style={s.rowLabel}><i className="bi bi-globe" style={{ marginRight: 5 }}></i>Visit Website</span>
                    <input type="text" style={s.input} placeholder="Button Text" value={row.buttonText} onChange={(e) => handleVisitWebsiteChange(row.id, 'buttonText', e.target.value)} />
                    <select style={s.select} value={row.dropdownValue} onChange={(e) => handleVisitWebsiteChange(row.id, 'dropdownValue', e.target.value)}>
                        <option value="Static">Static</option>
                        <option value="Dynamic">Dynamic</option>
                    </select>
                    <div style={{ flex: 2 }}>
                        <input
                            type="text"
                            style={{ ...s.input, ...(row.url && !isValidDomain(row.url, row.dropdownValue) ? s.inputError : {}) }}
                            placeholder={row.dropdownValue === 'Static' ? 'http://yourdomainname.com' : 'http://yourdomainname.com/{{1}}'}
                            maxLength="2000"
                            value={row.url}
                            onChange={(e) => handleVisitWebsiteChange(row.id, 'url', e.target.value)}
                        />
                        {row.url && !isValidDomain(row.url, row.dropdownValue) && (
                            <span style={s.errorText}>Please enter a valid domain. For dynamic URLs, include parameter values.</span>
                        )}
                    </div>
                    <button style={s.removeBtn} onClick={() => handleRemoveVisitWebsiteRow(row.id)} title="Remove"><i className="bi bi-trash"></i></button>
                </div>
            ))}

            {/* Quick Reply rows */}
            {customQuickReplyRows.map((row) => (
                <div key={row.id} style={s.row}>
                    <span style={s.rowLabel}><i className="bi bi-reply" style={{ marginRight: 5 }}></i>Quick Reply</span>
                    <input type="text" style={{ ...s.input, flex: 3 }} placeholder="Enter Button Text" maxLength="25" value={row.buttonText} onChange={(e) => handleCustomQuickReplyChange(row.id, e.target.value)} />
                    <button style={s.removeBtn} onClick={() => handleRemoveCustomQuickReplyRow(row.id)} title="Remove"><i className="bi bi-trash"></i></button>
                </div>
            ))}

            {/* Marketing Opt-Out rows */}
            {marketingOptOutRows.map((row) => (
                <div key={row.id} style={{ ...s.row, alignItems: 'flex-start' }}>
                    <span style={{ ...s.rowLabel, paddingTop: 10 }}><i className="bi bi-megaphone" style={{ marginRight: 5 }}></i>Opt-Out</span>
                    <div style={{ flex: 3 }}>
                        <input type="text" style={{ ...s.input, background: '#f3f4f6', color: '#6b7280' }} value="Stop Promotion" disabled />
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 8 }}>
                            <input type="checkbox" id={`consent-${row.id}`} checked onChange={(e) => handleConsentChange(row.id, e.target.checked)} style={{ marginTop: 2, flexShrink: 0 }} />
                            <label htmlFor={`consent-${row.id}`} style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5 }}>
                                I understand that it's my responsibility to stop marketing messages to customers who opt out.
                            </label>
                        </div>
                    </div>
                    <button style={s.removeBtn} onClick={() => handleRemoveMarketingOptOutRow(row.id)} title="Remove"><i className="bi bi-trash"></i></button>
                </div>
            ))}

            <ToastContainer />
        </div>
    );
};

const s = {
    wrap: { display: 'flex', flexDirection: 'column', gap: 10, marginTop: 16 },
    addBtn: { display: 'inline-flex', alignItems: 'center', padding: '8px 16px', background: 'linear-gradient(to right, #2388e0, #1565c0)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
    dropMenu: { background: 'white', borderRadius: '10px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', border: '1px solid #e5e7eb', minWidth: 240, padding: '6px' },
    dropSection: { fontSize: '11px', fontWeight: '700', color: '#1565c0', textTransform: 'uppercase', letterSpacing: '0.06em', padding: '8px 12px 4px' },
    dropItem: { display: 'flex', alignItems: 'center', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', color: '#374151', fontWeight: '500', userSelect: 'none' },
    dropHint: { fontSize: '11px', color: '#9ca3af', marginLeft: 4 },
    dropDivider: { height: 1, background: '#f3f4f6', margin: '4px 8px' },
    row: { display: 'flex', alignItems: 'center', gap: 10, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px 14px', flexWrap: 'wrap' },
    rowLabel: { fontSize: '12px', fontWeight: '700', color: '#1565c0', minWidth: 100, display: 'flex', alignItems: 'center' },
    input: { flex: 1, padding: '8px 12px', fontSize: '13px', border: '1.5px solid #d1d5db', borderRadius: '7px', outline: 'none', color: '#111827', minWidth: 100 },
    inputError: { borderColor: '#ef4444' },
    select: { padding: '8px 12px', fontSize: '13px', border: '1.5px solid #d1d5db', borderRadius: '7px', outline: 'none', color: '#111827', background: 'white' },
    removeBtn: { background: '#fee2e2', border: 'none', color: '#dc2626', borderRadius: '6px', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 13, flexShrink: 0 },
    errorText: { fontSize: '11px', color: '#ef4444', display: 'block', marginTop: 3 },
};

export default AddButtonComponent;
